import styled from 'styled-components';
import Status from '../types/enum/Status';
import theme from '../styles/theme';
import { StyledText, TextSize } from './Text';
import FlexBox, { FlexGrow } from './FlexBox';
import Icon from './Icon';
import { useState } from 'react';
import ActivityInfoModal from './EventInfoModal';

export type ActivityProps = {
  title: string;
  startTime: string;
  endTime: string;
  left: string;
  top: string;
  height: string;
  info: any;
  width: string;
};

const StyledActivityBox = styled(FlexBox)<ActivityProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 0 16px;
  cursor: pointer;
  position: absolute;
  width: ${({ width }) => width};
  min-width: ${({ width }) => width};
  max-width: ${({ width }) => width};
  left: ${({ left }) => left};
  top: ${({ top }) => top};
  height: ${({ height }) => height};
  min-height: ${({ height }) => height};
  max-height: ${({ height }) => height};
  background: linear-gradient(
    90deg,
    rgb(176, 52, 52) 0%,
    rgb(24, 75, 104) 118.29%
  );
  box-shadow: rgb(0 0 0 / 12%) 0px 6px 35px;
  color: white;
  border: 1px solid #8d8d8d;
  border-radius: 4px;
  i {
    font-style: normal;
    margin-right: 5px;
  }
`;
const StyledActivity = ({ ...props }: ActivityProps): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedCompetency, setSelectedCompetency] = useState<any>({});

  return (
    <>
      <ActivityInfoModal
        isOpen={isModalOpen}
        setOpen={setIsModalOpen}
        event={props.info}
      />
      <StyledActivityBox
        direction="column"
        {...props}
        onClick={() => {
          setIsModalOpen(true);
        }}>
        <FlexGrow
          style={{
            flexGrow: 0,
            display: 'flex',
            flexDirection: 'row',
            width: 'inherit',
          }}>
          <StyledText
            fontWeight="500"
            style={{
              fontSize: '14px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            {props.title}
          </StyledText>
        </FlexGrow>
        <FlexGrow
          style={{
            flexGrow: 0,
            display: 'flex',
            flexDirection: 'row',
            width: 'inherit',
          }}>
          <StyledText
            fontWeight="500"
            style={{
              fontSize: '14px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}>
            {props.startTime}
            {'  -  '}
            {props.endTime}
          </StyledText>
        </FlexGrow>
      </StyledActivityBox>
    </>
  );
};

export default StyledActivity;
